const divCalendarModalFilter = {
  label: 'Filtrado por',
  closeModal: 'CANCELAR',
  done: 'APLICAR'
};

export default divCalendarModalFilter;
